import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import React from "react";

export const ConflictModal = ({ isOpen, onClose, onResolve, deviationArticle }) => {
	if (!deviationArticle) return null;

	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogTitle>Resolve Units Conflict for Article {deviationArticle.article_code}</DialogTitle>
			<DialogContent>
				<Typography>
					Please choose which quantity to use. This will update the value in both the order and the
					deviation.
				</Typography>
				<Box display="flex" justifyContent="space-around" mt={2} p={2}>
					<Button
						variant="contained"
						color="primary"
						onClick={() => onResolve(deviationArticle.article_code, deviationArticle.article_units)}
					>
						Use Deviation Units: <br /> <strong>{deviationArticle.article_units}</strong>
					</Button>
					<Button
						variant="outlined"
						color="secondary"
						onClick={() =>
							onResolve(deviationArticle.article_code, deviationArticle.order_article_units)
						}
					>
						Use Order Units: <br /> <strong>{deviationArticle.order_article_units}</strong>
					</Button>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
};
